import { defineComponent as p, openBlock as t, createElementBlock as l, mergeProps as u, unref as o, renderSlot as h, createElementVNode as e, createCommentVNode as m } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, v = { key: 1 }, A = { key: 2 }, M = { key: 3 }, V = { key: 4 }, H = { key: 5 }, f = {
  name: "ScalarIconMagnifyingGlassPlus"
}, w = /* @__PURE__ */ p({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: d, weight: n } = Z(r);
    return (i, a) => (t(), l("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      h(i.$slots, "default"),
      o(n) === "bold" ? (t(), l("g", g, a[0] || (a[0] = [
        e("path", { d: "M156,112a12,12,0,0,1-12,12H124v20a12,12,0,0,1-24,0V124H80a12,12,0,0,1,0-24h20V80a12,12,0,0,1,24,0v20h20A12,12,0,0,1,156,112Zm76.49,120.49a12,12,0,0,1-17,0L168,185a92.12,92.12,0,1,1,17-17l47.54,47.53A12,12,0,0,1,232.49,232.49ZM112,180a68,68,0,1,0-68-68A68.08,68.08,0,0,0,112,180Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), l("g", v, a[1] || (a[1] = [
        e("path", {
          d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Zm112,0a8,8,0,0,1-8,8H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24A8,8,0,0,1,152,112Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), l("g", A, a[2] || (a[2] = [
        e("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM144,120H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), l("g", M, a[3] || (a[3] = [
        e("path", { d: "M150,112a6,6,0,0,1-6,6H118v26a6,6,0,0,1-12,0V118H80a6,6,0,0,1,0-12h26V80a6,6,0,0,1,12,0v26h26A6,6,0,0,1,150,112Zm78.24,116.24a6,6,0,0,1-8.48,0l-51.38-51.38a86.15,86.15,0,1,1,8.48-8.48l51.38,51.38A6,6,0,0,1,228.24,228.24ZM112,186a74,74,0,1,0-74-74A74.09,74.09,0,0,0,112,186Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), l("g", V, a[4] || (a[4] = [
        e("path", { d: "M152,112a8,8,0,0,1-8,8H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), l("g", H, a[5] || (a[5] = [
        e("path", { d: "M148,112a4,4,0,0,1-4,4H116v28a4,4,0,0,1-8,0V116H80a4,4,0,0,1,0-8h28V80a4,4,0,0,1,8,0v28h28A4,4,0,0,1,148,112Zm78.83,114.83a4,4,0,0,1-5.66,0l-52.7-52.7a84.1,84.1,0,1,1,5.66-5.66l52.7,52.7A4,4,0,0,1,226.83,226.83ZM112,188a76,76,0,1,0-76-76A76.08,76.08,0,0,0,112,188Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  w as default
};
